import React, { useEffect, useState } from "react";
import styles from "./NatalChartPage.module.css";
import NavigationBar from "../../components/common/NavigationBar";
import Button from "../../components/common/Button";
import { useNatalChartStore } from "../../store/natalChartStore";
import Preloader from "../../components/common/Preloader";
import { fetchNatalChart } from "../../services/api/profile";
import { useNavigate } from "react-router-dom";

const NatalChartPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const chartData = useNatalChartStore((state) => state.natalChart);
  const setNatalChart = useNatalChartStore((state) => state.setNatalChart);
  const [isFullDescriptionVisible, setFullDescriptionVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      try {
        const needsFetch = !chartData || !chartData.summary?.trim();

        if (needsFetch) {
          const response = await fetchNatalChart();

          if (!response?.natalChart?.summary?.trim()) {
            console.warn("⚠️ Получена натальная карта, но summary отсутствует или пустое.");
            throw new Error("Нет данных summary");
          }

          setNatalChart(response.natalChart);
        }
      } catch (err) {
        console.error("❌ Ошибка загрузки карты:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [chartData, setNatalChart]);

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  const toggleDescription = () => {
    setFullDescriptionVisible((prev) => !prev);
  };

  const handleForecastClick = () => {
    navigate("/forecast");
  };

  if (loading || !chartData || !chartData.summary) {
    return <Preloader />;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Ваша натальная карта</h1>

      <div className={styles.circle}>
        <img
          src={`${process.env.REACT_APP_API_URL}${chartData.chart_svg_path}`}
          alt="Натальная карта"
        />
      </div>

      <p className={styles.description}>
        {isFullDescriptionVisible ? chartData.summary : chartData.summary.slice(0, 250) + "..."}
      </p>

      <div className={styles.buttons}>
        <Button onClick={toggleDescription}>
          {isFullDescriptionVisible ? "Скрыть описание" : "Подробное описание"}
        </Button>
        <Button onClick={handleForecastClick}>Прогноз</Button>
      </div>

      <NavigationBar active="home" />
    </div>
  );
};

export default NatalChartPage;
